import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PasskeyOtpGeneratePayload {
  preferenceType: string;
  username: string;
  passkeyToken: string;
  recaptchaToken?: string | null;
}

export interface PasskeyOtpGenerateState {
  loading: boolean;
  generated: boolean;
  error: any | null;
}

const initialState: PasskeyOtpGenerateState = {
  loading: false,
  generated: false,
  error: null,
};

const passkeyOtpGenerateSlice = createSlice({
  name: 'passkeyOtpGenerate',
  initialState,
  reducers: {
    passkeyOtpGenerateRequest(
      state,
      _action: PayloadAction<PasskeyOtpGeneratePayload>
    ) {
      state.loading = true;
      state.generated = false;
      state.error = null;
    },
    passkeyOtpGenerateSuccess(state) {
      state.loading = false;
      state.generated = true;
      state.error = null;
    },
    passkeyOtpGenerateFailure(state, action: PayloadAction<any>) {
      state.loading = false;
      state.generated = false;
      state.error = action.payload;
    },
    resetPasskeyOtpGenerate() {
      return initialState;
    },
  },
});

export const {
  passkeyOtpGenerateRequest,
  passkeyOtpGenerateSuccess,
  passkeyOtpGenerateFailure,
  resetPasskeyOtpGenerate,
} = passkeyOtpGenerateSlice.actions;

export default passkeyOtpGenerateSlice.reducer;
